import React from 'react';
import { Link } from 'react-router-dom'; // Import Link
import { useAuthContext } from '../../context/AuthContext'; // Import the auth context hook

const AdminDashboardPage = () => {
  const { logout } = useAuthContext(); // Get the logout function from context

  return (
    <>
      {/* Page Title */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Admin Dashboard</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item"><a href="/admin">Admin</a></li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      
      <div className="d-flex justify-content-end align-items-center mb-4">
        <div> {/* Container for multiple buttons */}
          {/* Initiate Visit Button */}
          <Link to="/admin/initiate-visit" className="btn btn-primary me-2">
            <i className="fas fa-play-circle me-1"></i> Initiate Visit
          </Link>
          {/* Cases Button */}
          <Link to="/admin/cases" className="btn btn-secondary me-2">
            <i className="fas fa-folder me-1"></i> Cases
          </Link>
          {/* Note Templates Button */}
          <Link to="/admin/note-templates" className="btn btn-info me-2">
            <i className="fas fa-file-alt me-1"></i> Notes Module
          </Link>
          {/* MFA Module Button */}
          <Link to="/admin/mfa-module" className="btn btn-primary me-2">
            <i className="fas fa-shield-alt me-1"></i> MFA Module
          </Link>
          {/* Logout Button */}
          {/* <button className="btn btn-danger" onClick={logout}>
            <i className="fas fa-sign-out-alt me-1"></i> Logout
          </button> */}
        </div>
      </div>
      
      <div className="row">
        <div className="col-md-6 col-xl-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="text-muted fw-medium">Forms</h5>
                  <h4 className="mb-0">12</h4>
                </div>
                <div className="avatar-sm rounded-circle bg-primary align-self-center">
                  <span className="avatar-title rounded-circle bg-primary">
                    <i className="fas fa-file-alt text-white font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-md-6 col-xl-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="text-muted fw-medium">Health Systems</h5>
                  <h4 className="mb-0">5</h4>
                </div>
                <div className="avatar-sm rounded-circle bg-success align-self-center">
                  <span className="avatar-title rounded-circle bg-success">
                    <i className="fas fa-hospital text-white font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-md-6 col-xl-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="text-muted fw-medium">Users</h5>
                  <h4 className="mb-0">24</h4>
                </div>
                <div className="avatar-sm rounded-circle bg-info align-self-center">
                  <span className="avatar-title rounded-circle bg-info">
                    <i className="fas fa-users text-white font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col-md-6 col-xl-3">
          <div className="card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-grow-1">
                  <h5 className="text-muted fw-medium">Active Sessions</h5>
                  <h4 className="mb-0">8</h4>
                </div>
                <div className="avatar-sm rounded-circle bg-warning align-self-center">
                  <span className="avatar-title rounded-circle bg-warning">
                    <i className="fas fa-video text-white font-size-24"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="row">
        <div className="col-xl-6">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title mb-4">Recent Activity</h4>
              
              <ul className="list-group list-group-flush">
                <li className="list-group-item px-0">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-xs">
                        <span className="avatar-title rounded-circle bg-light text-primary">
                          <i className="fas fa-file-alt"></i>
                        </span>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14">New form created</h5>
                      <p className="text-muted">Patient Intake Form v2</p>
                      <div className="text-muted">
                        <i className="far fa-clock me-1"></i> 5 minutes ago
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item px-0">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-xs">
                        <span className="avatar-title rounded-circle bg-light text-success">
                          <i className="fas fa-hospital"></i>
                        </span>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14">Health system updated</h5>
                      <p className="text-muted">Memorial Healthcare</p>
                      <div className="text-muted">
                        <i className="far fa-clock me-1"></i> 1 hour ago
                      </div>
                    </div>
                  </div>
                </li>
                <li className="list-group-item px-0">
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <div className="avatar-xs">
                        <span className="avatar-title rounded-circle bg-light text-info">
                          <i className="fas fa-user"></i>
                        </span>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14">New user added</h5>
                      <p className="text-muted">Dr. Sarah Johnson</p>
                      <div className="text-muted">
                        <i className="far fa-clock me-1"></i> 3 hours ago
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="col-xl-6">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title mb-4">System Status</h4>
              
              <div className="mb-4">
                <h5 className="font-size-14">API Server</h5>
                <div className="progress">
                  <div className="progress-bar bg-success" role="progressbar" style={{ width: '92%' }} aria-valuenow="92" aria-valuemin="0" aria-valuemax="100">92%</div>
                </div>
              </div>
              
              <div className="mb-4">
                <h5 className="font-size-14">Database</h5>
                <div className="progress">
                  <div className="progress-bar bg-success" role="progressbar" style={{ width: '85%' }} aria-valuenow="85" aria-valuemin="0" aria-valuemax="100">85%</div>
                </div>
              </div>
              
              <div className="mb-4">
                <h5 className="font-size-14">Storage</h5>
                <div className="progress">
                  <div className="progress-bar bg-warning" role="progressbar" style={{ width: '78%' }} aria-valuenow="78" aria-valuemin="0" aria-valuemax="100">78%</div>
                </div>
              </div>
              
              <div>
                <h5 className="font-size-14">Memory</h5>
                <div className="progress">
                  <div className="progress-bar bg-info" role="progressbar" style={{ width: '65%' }} aria-valuenow="65" aria-valuemin="0" aria-valuemax="100">65%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default AdminDashboardPage;